export default "__VITE_ASSET__DtsQuFSO__"